import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router';
import { Typography, Box, Breadcrumbs } from '@material-ui/core';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';

import IssuesList from '../IssuesList';
import ProductDescription from './ProductDescription';

import { useIssuesDesktopStyles } from './styles';

import { textInCapitalCase } from '../../../../../../helpers/TextHelper';

import { PURCHASE_ROUTE } from '../../../../../../constants/Routes';
import Loader from '../../tracking/trackingLoading.gif';

import EmptyState from '../../../../../common/EmptyState';
import BearEmptyState from '../../../../../../assets/bearEmpty.svg';
import EmptyStateText from '../EmptyStateText';
import { contactUrl } from '../../../../../../config/paths';

const IssuesDesktop = ({ ...props }) => {
  const { issues, product, loading, error } = props;
  const history = useHistory();
  const classes = useIssuesDesktopStyles();

  return (
    <Box>
      <Typography className={classes.title}>Reportar inconveniente</Typography>
      <Breadcrumbs
        classes={{ root: classes.rootBreadcrumb }}
        separator={<NavigateNextIcon fontSize="inherit" />}
        aria-label="breadcrumb"
      >
        <Typography
          className={classes.firstBreadcrumb}
          onClick={() => history.push(PURCHASE_ROUTE)}
        >
          Compras realizadas
        </Typography>
        <Typography className={classes.secondBreadcrumb}>
          {textInCapitalCase(product.name)}
        </Typography>
      </Breadcrumbs>
      <ProductDescription
        image={product.thumbnailImage}
        name={product.name}
        orderId={product.orderId}
        quantity={product.quantity}
        totalPrice={product.totalPrice}
        purchaseDate={product.purchaseDate}
      />
      {!loading && !error && (
        <React.Fragment>
          <Typography className={classes.subtitle}>
            Selecciona el motivo de tu inconveniente:
          </Typography>
          <IssuesList issues={issues} product={product} />
        </React.Fragment>
      )}
      {loading && <img className={classes.loader} src={Loader} />}
      {!loading && error && (
        <EmptyState
          text={<EmptyStateText />}
          buttonText="Ir a formulario"
          image={BearEmptyState}
          onClick={() => window.open(contactUrl, '_blank')}
        />
      )}
    </Box>
  );
};

IssuesDesktop.propTypes = {
  issues: PropTypes.array,
  product: PropTypes.object,
  loading: PropTypes.bool,
  error: PropTypes.bool,
};

export default IssuesDesktop;
